<div class="algorithm-page container py-4">
  <h2>Algorithm</h2>
  <p class="subtitle">
    Tune how each discovery feed ranks profiles. Weights are entered as
    percentages that sum to 100%.
  </p>

  <mat-card>
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Home / Swipe">
        <sa-algorithm-feed-form feed="home_swipe"></sa-algorithm-feed-form>
      </mat-tab>
      <mat-tab label="Most Eligible">
        <sa-algorithm-feed-form feed="most_eligible"></sa-algorithm-feed-form>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
